/// <reference path="../../app.d.ts"/>

import { User } from '../../../../../shared/models/api/User/User';
import { BasicUserService } from '../../../../../shared/services/BasicUserService';
import { AppPersistenceService } from '../services/AppPersistenceService';
import { defaults } from '../defaults';
import { AppUtils } from '../../../../../shared/utils/index';
import { InputPageController } from './steps/InputPageController';

export class App implements AppController {
	private stepController?: StepController;
	private readonly appPersistanceService: AppPersistenceService;
	private readonly userService: BasicUserService<AdvertisngConsentAppDefinition>;
	private readonly $ctx: JQuery;
	private readonly options: BasicAppOptions<AdvertisngConsentAppDefinition>;
	private readonly loader: BasicLoader<AdvertisngConsentAppDefinition>;

	 
	constructor(element: HTMLElement | JQuery, options: BasicAppOptions<AdvertisngConsentAppDefinition>, loader: BasicLoader<AdvertisngConsentAppDefinition>) {
		this.loader = loader;
		this.options = $.extend(true, {}, defaults, options);
		this.$ctx = this.options.$ctx;

		this.userService = new BasicUserService(this.options);
		this.appPersistanceService = new AppPersistenceService(this.options);
	}

	public start(): void {
		this.callDependencyLoader();
	}

	public callDependencyLoader(): void {
		this.loader._loadDependencies(this.initApplication.bind(this));
	}

	public initApplication(): void {
		AppUtils.View.startLoader();
		this.appPersistanceService.prepareApplicationSession();
		this.userService.getUser((user: User) => {
			const token = AppUtils.Url.getUrlParameter('datatoken');
			if (token && !user.Valid) {
				const decodedToken = this.decodeFromBinary(token);
				if (!AppUtils.Helper.isEmptyString(decodedToken)) {
					this.mapDecodedTokenParams(decodedToken);
				}
			}

			this.stepController = new InputPageController(this, this.options, this.loader, user);
			this.stepController.start();
		});
	}

	private decodeFromBinary(token: string): string {
		try {
			return decodeURIComponent(window.atob(token).split('').map((c) => {
				const utfShift = (`00${c.charCodeAt(0).toString(16)}`).slice(-2);
				return `%${utfShift}`;
			}).join(''));
		}
		catch (ex) {
			AppUtils.Helper.logError(`cannot decode token ${token}`, this.options.name, window.location.href);
			return "";
		}
	}

	private mapDecodedTokenParams(decodedToken: string): void {
		const userParams = this.createParamObj(decodedToken);
		const formModel = this.appPersistanceService.getFormModelFromStore();

		if (userParams && userParams.number && userParams.number.length < 9) {
			userParams.number = userParams.number.padStart(9, "0");
		}
		formModel.PersonalData.Mitgliedsnummer = userParams.number || undefined;
		formModel.PersonalData.Vorname = userParams.firstname || undefined;
		formModel.PersonalData.Nachname = userParams.lastname || undefined;
		formModel.PersonalData.Adresse.Ort = userParams.place || undefined;
		formModel.PersonalData.Adresse.StrasseHausnummer = userParams.street || undefined;
		formModel.PersonalData.Adresse.Postleitzahl = userParams.zip || undefined;
		formModel.PersonalData.Email = userParams.email || undefined;
		formModel.PersonalData.TelefonNummer = userParams.phone1 || undefined;
		formModel.PersonalData.TelefonGeschaeftlichNummer = userParams.phone2 || undefined;
		this.appPersistanceService.setFormModelToStore(formModel);
	}

	private createParamObj(tokenString: string): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		const split = tokenString.split("&");
		split.forEach(part => {
			const partSplit = part.split("=");
			result[partSplit[0]] = partSplit[1];
		});
		return result;
	}

	public afterRenderApp(): void {
		this.loader.initAdditionalModules(this.$ctx);
		AppUtils.View.stopLoader();
		this.loader.complete();
	}
}